import { render } from "./Exhibition.vue?vue&type=template&id=fa2675e0&scoped=true"
import script from "./Exhibition.vue?vue&type=script&lang=js"
export * from "./Exhibition.vue?vue&type=script&lang=js"

import "./Exhibition.vue?vue&type=style&index=0&id=fa2675e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2675e0"]])

export default __exports__